import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Order, OrderPayment, OrderReview } from '@shared/models';
import { OrderService } from '@app/resources/services/order.service';

export interface PagedOrders {
  orders: Order[];
  totalTransactions: number;
}

@Injectable()
export class OrdersApiService {
  private readonly orderService = inject(OrderService);

  getByMerchantId(merchantId: number, pageNumber: number, pageSize: number, query?: string): Observable<PagedOrders> {
    return this.orderService.findByMerchantId(merchantId, pageNumber, pageSize, query).pipe(
      map((result: any) => ({
        orders: (result?.orders?.$values ?? []).map(mapToOrder),
        totalTransactions: result?.totalTransactions ?? 0,
      }))
    );
  }
}

function mapToOrder(data: any): Order {
  return {
    OrderId: data.orderId,
    OrderGuid: data.orderGuid ?? undefined,
    EmployeeId: data.employeeId ?? undefined,
    StatusType: data.statusType,
    EnrollmentType: data.enrollmentType,
    AmountTotal: data.amountTotal,
    StartDateTime: data.startDateTime,
    OrderPayments: (data.orderPayments?.$values ?? data.orderPayments ?? []).map(mapToOrderPayment),
    OrderReviews: (data.orderReviews?.$values ?? data.orderReviews ?? []).map(mapToOrderReview),
    OriginSDK: data.originSDK ?? false,
  };
}

function mapToOrderPayment(data: any): OrderPayment {
  return {
    OrderPaymentId: data.orderPaymentId,
    ConsumerId: data.consumerId ?? undefined,
    ReferenceIdent: data.referenceIdent ?? undefined,
  };
}

function mapToOrderReview(data: any): OrderReview {
  return {
    OrderReviewId: data.orderReviewId,
    Score: data.score,
  };
}
